import { render, staticRenderFns } from "./PopupViewTwo.vue?vue&type=template&id=0534c5e2&scoped=true&"
import script from "./PopupViewTwo.vue?vue&type=script&lang=js&"
export * from "./PopupViewTwo.vue?vue&type=script&lang=js&"
import style0 from "./PopupViewTwo.vue?vue&type=style&index=0&id=0534c5e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534c5e2",
  null
  
)

export default component.exports